module.exports = __webpack_public_path__ + "static/media/Carroceria.5d2f55eb.svg";